import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
import DataRoaming from "@/data/AdminPanel/DataRoaming";
import ApiRoaming from "@/api/ApiRoaming";
let RoamingZoneEdit = class RoamingZoneEdit extends Vue {
    constructor() {
        super(...arguments);
        this.HasLoading = false;
        this.Breadcrumbs = DataRoaming.RoamingZoneCreateBreadcrumbs;
        this.newRoamingZone = {
            uuid: this.CurrentRoamingZoneUUID,
            zone_name: "",
            zone_order: 10,
            group_1_call_price: 0,
            group_2_call_price: 0,
            group_3_call_price: 0,
            group_4_call_price: 0,
            group_5_call_price: 0,
            group_1_sms_price: 0,
            group_2_sms_price: 0,
            group_3_sms_price: 0,
            group_4_sms_price: 0,
            group_5_sms_price: 0,
            incoming_call_price: 0,
            data_mb_price: 0,
        };
    }
    async getZoneInfo() {
        const zoneInfo = await ApiRoaming.GetRoamingZoneByUUID(ApiEnter.CurrentSessionUUID, this.CurrentRoamingZoneUUID);
        if (zoneInfo == undefined) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            }).then(() => {
                this.$router.go(-1);
            });
            return;
        }
        this.newRoamingZone.zone_name = zoneInfo.zone_name;
        this.newRoamingZone.zone_order = zoneInfo.zone_order;
        this.newRoamingZone.group_1_call_price = zoneInfo.group_1_call_price;
        this.newRoamingZone.group_2_call_price = zoneInfo.group_2_call_price;
        this.newRoamingZone.group_3_call_price = zoneInfo.group_3_call_price;
        this.newRoamingZone.group_4_call_price = zoneInfo.group_4_call_price;
        this.newRoamingZone.group_5_call_price = zoneInfo.group_5_call_price;
        this.newRoamingZone.group_1_sms_price = zoneInfo.group_1_sms_price;
        this.newRoamingZone.group_2_sms_price = zoneInfo.group_2_sms_price;
        this.newRoamingZone.group_3_sms_price = zoneInfo.group_3_sms_price;
        this.newRoamingZone.group_4_sms_price = zoneInfo.group_4_sms_price;
        this.newRoamingZone.group_5_sms_price = zoneInfo.group_5_sms_price;
        this.newRoamingZone.incoming_call_price = zoneInfo.incoming_call_price;
        this.newRoamingZone.data_mb_price = zoneInfo.data_mb_price;
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            if (this.newRoamingZone.zone_name == null ||
                this.newRoamingZone.zone_order == null || // или typeof this.newRoamingZone.zone_order !== 'number'
                this.newRoamingZone.group_1_call_price == null ||
                this.newRoamingZone.group_2_call_price == null ||
                this.newRoamingZone.group_3_call_price == null ||
                this.newRoamingZone.group_4_call_price == null ||
                this.newRoamingZone.group_5_call_price == null ||
                this.newRoamingZone.group_1_sms_price == null ||
                this.newRoamingZone.group_2_sms_price == null ||
                this.newRoamingZone.group_3_sms_price == null ||
                this.newRoamingZone.group_4_sms_price == null ||
                this.newRoamingZone.group_5_sms_price == null ||
                this.newRoamingZone.incoming_call_price == null ||
                this.newRoamingZone.data_mb_price == null) {
                throw new Error("Одно из свойства не заполнено");
            }
            try {
                const response = await ApiRoaming.UpdateRoamingZone(ApiEnter.CurrentSessionUUID, this.newRoamingZone.zone_name, Number(this.newRoamingZone.zone_order), Number(this.newRoamingZone.group_1_call_price), Number(this.newRoamingZone.group_2_call_price), Number(this.newRoamingZone.group_3_call_price), Number(this.newRoamingZone.group_4_call_price), Number(this.newRoamingZone.group_5_call_price), Number(this.newRoamingZone.group_1_sms_price), Number(this.newRoamingZone.group_2_sms_price), Number(this.newRoamingZone.group_3_sms_price), Number(this.newRoamingZone.group_4_sms_price), Number(this.newRoamingZone.group_5_sms_price), Number(this.newRoamingZone.incoming_call_price), Number(this.newRoamingZone.data_mb_price), this.CurrentRoamingZoneUUID);
                if (typeof response == "boolean") {
                    sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_updated"),
                        icon: "success",
                    }).then(() => {
                        this.$router.go(-1);
                    });
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
            catch (e) {
                console.error(e);
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
            this.HasLoading = false;
        }
    }
    created() {
        this.CurrentRoamingZoneUUID = this.$route.params.zone_uuid;
        this.getZoneInfo();
    }
};
RoamingZoneEdit = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RoamingZoneEdit);
export default RoamingZoneEdit;
